import { useRequest } from 'ahooks'
import { Card, Typography } from 'antd'
import moment from 'moment'
import qs from 'query-string'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { MosaicComponent, RiskBar, getPointPermission, getRiskColor, getRiskText } from '@/components'
import { ReportExtras } from '@/components/reports/report-extra.component'
import { PAGE_RESOURCE_POINTS_ENUM, ReportConfiguration, Resource } from '@/schemas'

interface ProjectReportProps {
  resource: Resource
}

export const ResourceReport: React.FC<ProjectReportProps> = ({ resource }) => {
  const { t } = useTranslation()

  const { canRead } = getPointPermission(PAGE_RESOURCE_POINTS_ENUM.周报_内容, resource.permissions)

  const { data, run } = useRequest<ReportConfiguration>(
    {
      url: '/api/report/getReportConfig',
      params: {
        selfId: resource.lastestWrite?.selfId,
        type: resource.lastestWrite?.type,
        startDate: moment(resource.lastestWrite?.startDate).isoWeekday(1).format('ll'),
      },
    },
    {
      manual: true,
    }
  )

  React.useEffect(() => {
    if (resource.lastestWrite) {
      run()
    }
  }, [resource.lastestWrite])

  if (!data) return null

  const title = (
    <span className='text-base'>
      {t('risk level')}：
      <span style={{ color: getRiskColor(resource.risk) }}>{getRiskText({ risk: resource.risk, t })}</span>
    </span>
  )

  const extra = resource.lastestWrite && (
    <Link
      to={`${window.location.pathname}?${qs.stringify({
        tab: 'report',
        startDate: moment(resource.lastestWrite.updatedAt).isoWeekday(1).format('ll'),
      })}`}
    >
      {moment(resource.lastestWrite.updatedAt).format('l')} {t('updated')}
    </Link>
  )

  const content = resource.lastestWrite ? (
    <div className='flex items-stretch'>
      {!resource['evaluation'] && <RiskBar risk={resource.risk} />}
      <ReportExtras
        report={resource.lastestWrite as any}
        editable={false}
        extraFields={data.modules.find((m) => m.isExtra)?.fields || []}
      />
    </div>
  ) : (
    <Typography.Text type='secondary'>{t('unfilled')}</Typography.Text>
  )

  return (
    <Card size='small' bordered={false} className='!mb-16px !-ml-12px' title={title} extra={extra}>
      {canRead ? content : <MosaicComponent />}
    </Card>
  )
}
